import React, { useState, useCallback, useEffect } from 'react'
import { Row, Col, Modal, Avatar, Button, Form, Input, Slider } from 'antd'
import FileBase64 from "react-file-base64";
import { uploadImageValidate, IconHelper } from './../helpers'
import getCroppedImg from './../helpers/CropImageHelper'
import _, { isEmpty } from 'lodash'
import Cropper from 'react-easy-crop'
import ImageResize from "image-resize";

import analytics from '../libs/analytics'


const CropImage = ({t, setProfilePic, setCropImageProfile ,profilePic, getAvatar}) => {
    const {IconEditProfile,  IconZoomOut, IconZoomIn } = IconHelper
    const [isOpenCrop, setIsOpenCrop] = useState(false)
    const [imageCrop, setImageCrop] = useState("")
    const [errorImage, setErrorImage] = useState(false)
    const [imageName, setImageName] = useState("");
    const [theInputKey, setTheInputKey] = useState("")
    const [zoom, setZoom] = useState(1)
    const [crop, setCrop] = useState({
        x: 0, y: 0
    })
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState('')

    const imageResize = new ImageResize({
        format: "png", // ไฟล์รูปภาพเป็น png
        quality: 0.5, // ปรับขนาดไฟล์รูปภาพให้เหลือครึ่งนึง
        width: 500, // ปรับขนาดรูปให้มีความกว้าง 500 px
        height: 500
    });
    

    useEffect(() => {
        const tagFile = document.getElementsByTagName("input")[1]
        tagFile.accept = ".jpg, .png"

    }, [])

    const getFiles = (files) => {

        if (_.has(files, "base64") && uploadImageValidate(files.type, files.size)) {
            
            imageResize
            .play(URL.createObjectURL(files.file)) //แปลงไฟล์เป็น blob
            .then(function (response) {
              var i = new Image();
              i.onload = function () {
                  //console.log('response',response)
                  setImageCrop(response)
                  setImageName(files.name)
                  setErrorImage(false)
                   let randomString = Math.random().toString(36);
                    setTheInputKey(randomString)
                    const tagFile = document.getElementsByTagName("input")[1]
                    tagFile.accept = ".jpg, .png"
                    setIsOpenCrop(true)
                  
                
              };
              i.src = response;
            })
            .catch(function (error) {
              console.error(error);
            });
           
            //this.props.uploadFile({ file: files.base64 });
           
            // setIsOpenCrop(true)
            // setImageCrop(files.base64)
            // setImageName(files.name)
            // setErrorImage(false)
            // let randomString = Math.random().toString(36);
            // setTheInputKey(randomString)
            // const tagFile = document.getElementsByTagName("input")[1]
            // tagFile.accept = ".jpg, .png"
		} else {
            setErrorImage(true)
            console.log("File type accept (Image/*) and File size upload max 2 MB")
        }

    }


    const handleCancle = () => {
        const tagFile = document.getElementsByTagName("input")[1]
        tagFile.accept = ".jpg, .png"
        setIsOpenCrop(false)
        setTimeout(() => {
            setZoom(1)
        }, 500);
        // setImageUseCrop(img)
    }


    const handleForm = (e) => {
        setImageName(e.target.value)
        setProfilePic(e.target.value)
    }

    const handleonChoosFile = (e) => {
        analytics.sendEvent({
            category:'My Profile',
            action: 'MyProfile-ChooseFile-Button-Clicked',
        });
    }


    const onCropChange = crop => {
        setCrop(crop)
    }

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const onZoomChange = zoom => {

        setZoom(zoom)
    }

    const showCroppedImage = useCallback(async () => {
        try {

          const croppedImage = await getCroppedImg(
            imageCrop,
            croppedAreaPixels,
            0
          )
          const tagFile = document.getElementsByTagName("input")[1]
            tagFile.accept = ".jpg, .png"
          setCroppedImage(croppedImage)
          setIsOpenCrop(false)
          setProfilePic(imageName)

          let block = croppedImage.split(";");
          let realData = block[1].split(",")[1];
          setCropImageProfile(realData)
          setTimeout(() => {
            setZoom(1)
        }, 500);
        } catch (e) {
            console.error(e)
        }
    }, [croppedAreaPixels, imageCrop, imageName, setCropImageProfile, setProfilePic])

    const ShowImageProfile = () => {

        if (getAvatar !== "" && croppedImage === "") {
            return <Avatar size={100} src={getAvatar} style={{ marginTop: "40px" }} />
        }
        if (getAvatar !== "" && croppedImage !== "") {
            return <Avatar size={100} src={croppedImage} style={{ marginTop: "40px" }} />
        }
        if (getAvatar === "") {
            if(!isEmpty(croppedImage)) {
                return <Avatar size={100} src={croppedImage} style={{ marginTop: "40px" }} />
            } else {
                return <IconEditProfile style={{marginTop: "40px"}} />
            }
            
        }
    }


    return (
        <>
            <Row type="flex" justify="center">
                <div className="user-profile-avatar">

                    {ShowImageProfile()}
                    {/* {_.isNull(getAvatar) ? (
                        <IconEditProfile style={{marginTop: "40px"}} />
                    ):(
                        <Avatar size={100} src={getAvatar} style={{marginTop: "40px"}} />
                    )}
                    */}


                </div>

            </Row>
            <Form.Item
                name="avatar"
                className="v-room-duration-input"
                label={t('edit_profile.input.profile')}
                validateStatus={errorImage ? "error" : "success"}
                help={errorImage && t('edit_profile.error.profile_pic')}
            >
                <Row>
                    <Col span={18}>
                        <Input name="avatar" value={profilePic} onChange={e => handleForm(e)} placeholder={t('edit_profile.input.profile')} />

                    </Col>
                    <Col span={5}>
                        <div className="boxProfile round-button">
                            <Button  >
                                {t('edit_profile.input.choose_file')}
                            </Button>
                            <div onClick={handleonChoosFile} key={theInputKey || ''}>
                            <FileBase64
                                multiple={false}
                                onDone={getFiles.bind(this)}
                            />
                            </div>
                           
                        </div>

                    </Col>
                </Row>
            </Form.Item>

            <Modal

                visible={isOpenCrop}
                onCancel={handleCancle}
                closable={false}
                footer={
                    [

                        <Button key="submit" className="btn-submit-crop-image" type="danger" htmlType="submit" onClick={showCroppedImage}>
                            {t('edit_profile.input.btn_ok')}
                        </Button>,
                        <Button key="back" htmlType="button" onClick={handleCancle} className="btn-submit-cancel-crop-image">
                            {t('edit_profile.input.btn_cancel')}
                        </Button>
                    ]
                }
                className="popup-crop-image"

            >
                <Row type="flex" justify="center">
                    <Col span={17}>
                        <div className="editProfiletitle">
                            {t('edit_profile.edit_image')}
                        </div>

                    </Col>

                </Row>
                <Row type="flex" justify="centeer">
                    <Col lg={24}>
                        <div className="cropContainer">
                            <Cropper
                                image={imageCrop}
                                crop={crop}
                                zoom={zoom}
                                aspect={1}
                                cropShape="round"
                                showGrid={false}
                                onCropChange={onCropChange}
                                onCropComplete={onCropComplete}
                                onZoomChange={onZoomChange}

                            />
                        </div>
                    </Col>
                </Row>
                <Row type="flex" justify="center" style={{ marginTop: "20px" }}>

                    <IconZoomOut
                        style={{ marginTop: "7px", marginRight: "5px" }}
                        width={20}
                        height={20}
                    />
                    <Col span={18}>
                        <div className="sliderZoom">
                            <Slider
                                value={zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                onChange={(zoom) => onZoomChange(zoom)}
                            />
                        </div>

                    </Col>
                    <IconZoomIn style={{ marginTop: "5px" }} width={20} height={20} />
                </Row>


            </Modal>
        </>
    )
}

export default CropImage